/* tslint:disable */
/* eslint-disable */
/* @relayHash 4137bc8b06a9654c01434b74e88a2ea8 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardRouteQueryVariables = {};
export type DashboardRouteQueryResponse = {
    readonly firstSite: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly name: string;
            };
        }>;
    };
    readonly " $fragmentRefs": FragmentRefs<"DashboardContainer_query">;
};
export type DashboardRouteQuery = {
    readonly response: DashboardRouteQueryResponse;
    readonly variables: DashboardRouteQueryVariables;
};



/*
query DashboardRouteQuery {
  firstSite: sites(first: 1) {
    edges {
      node {
        id
        name
      }
    }
  }
  ...DashboardContainer_query
}

fragment DashboardContainer_query on Query {
  sites(first: 20) {
    edges {
      node {
        id
        name
        ...DashboardSiteContainer_site
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment DashboardSiteContainer_site on Site {
  id
  name
  createdAt
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any), v2 = ({
        "alias": "firstSite",
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            }
        ],
        "concreteType": "SitesConnection",
        "kind": "LinkedField",
        "name": "sites",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "SiteEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Site",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v1 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "sites(first:1)"
    } as any), v3 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 20
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "DashboardRouteQuery",
            "selections": [
                (v2 /*: any*/),
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DashboardContainer_query"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "DashboardRouteQuery",
            "selections": [
                (v2 /*: any*/),
                {
                    "alias": null,
                    "args": (v3 /*: any*/),
                    "concreteType": "SitesConnection",
                    "kind": "LinkedField",
                    "name": "sites",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SiteEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Site",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v1 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "createdAt",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "sites(first:20)"
                },
                {
                    "alias": null,
                    "args": (v3 /*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "SitesConfig_sites",
                    "kind": "LinkedHandle",
                    "name": "sites"
                }
            ]
        },
        "params": {
            "id": "4137bc8b06a9654c01434b74e88a2ea8",
            "metadata": {},
            "name": "DashboardRouteQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '930e73beb7bd9d8fda6b69a69d971e72';
export default node;
